import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from "@material-ui/core";

const useStyles = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "50%",
  },
});

function CircularIndeterminate({classes}) {

  return (
    <div className={classes.root}>
      <CircularProgress />
    </div>
  );
}


export default withStyles(useStyles, { withTheme: true })(CircularIndeterminate);